import axios from "axios";
import { ServerGridConfig } from "../../config/GridConfig";
import RootStore from "../RootStore/RootStore";
import API_URL from "../../config/ApiUrl";
import { makeAutoObservable } from 'mobx';
import dayjs from "dayjs";

export default class PlatformBookingStore {
	list_data = null;
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	searchValue = '';
	checkIn = dayjs(new Date()).toDate().toISOString();
	checkOut = dayjs(new Date()).add(15, 'days').toDate().toISOString();
	propertyId = '';
	propertyList = [];

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if(this.agGrid) {
			this.agGrid.api.paginationPageSize(parseInt(page));
		}
	};

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue,
				);
				this.getList({
					...payload,
					checkIn: this.checkIn,
					checkOut: this.checkOut,
					propertyId: this.propertyId
				})
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};
	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.RESERVATION.LIST}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&checkIn=${payload.checkIn}&checkOut=${payload.checkOut}&ePropertyId=${payload.propertyId}`
			);
			return data.data;
		} catch { }
	};
	getPropertyLookup = async () => {
		try {
			const { data } = await axios.get(
				`${API_URL.ACCOMMODATION.LIST}?pageNo=1&pageSize=1000&sortBy=propertyName%20asc&searchValue=&isActive=1`
			);
			this.propertyList = data?.data?.data?.map(p => ({
				propertyName: p.propertyName,
				ePropertyId: p.id
			})) ?? [];
			return this.propertyList;
		} catch (error) {
			console.error("Error fetching property lookup:", error);
			this.propertyList = [];
		}
	};
	exportPlatformBooking = async () => {
		try {
			const payload = {
				pageNo: 1,
				pageSize: 2147483647,
				sortBy: "checkInDate desc",
				searchValue: this.searchValue || "",
				checkIn: this.checkIn,
				checkOut: this.checkOut,
				recordStatus: 1
			};

			const response = await axios.post(`${API_URL.RESERVATION.EXPORT}`, payload, {
				responseType: 'blob',
			});

			const blob = new Blob([response.data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			const url = window.URL.createObjectURL(blob);

			const link = document.getElementById('export-download-link');
			if (link) {
				link.href = url;

				const timestamp = dayjs().format('DD-MM-YYYY_HHmm');
				link.setAttribute('download', `PlatformBooking_Records_${timestamp}.xlsx`);

				link.click();
			}

			setTimeout(() => window.URL.revokeObjectURL(url), 1000);

		} catch (error) {
			console.error("Export failed:", error);
		}
	};
	cancelBooking = async ({ id, versionNo }) => {
		try {
			const encodeURL = '?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.put(
				API_URL.RESERVATION.CANCELBOOKING + encodeURL
			);
			this.setupGrid(this.agGrid);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};

}
